<template lang='pug'>
    main.pp
        h2 Adatkezelési és továbbítási nyilatkozat

        p Az oldalra való belépéshez nincs szükség jelszóra, az email címére kapott jelszóval tud bejelentkezni. Fiókját bármikor törölheti. Adatait kizárólag azért tároljuk, hogy belépéskor ne kelljen minden alkalommal kitöltenie a támogató nyilatkozatot. Az Önről nálunk tárolt összes adatot letöltheti és megnézheti az "Adataim" gombra kattintva.

        p A bankkártya adatokat semmilyen módon nem tároljuk, a fizetést az OTP SimplePay rendszere kezeli. Újabb támogatási igény esetén a bankkártya adatait újra meg kell adnia.<br/>

        p Személyes adataira a fizetéshez van szükség, ezek a fiókja megszüntetésével véglegesen törlésre kerülnek. Semmilyen indokkal nem adjuk át harmadik félnek és nem használjuk fel más célra vagy más módon.

        p Ezúton beleegyezik az adattovábbítási nyilatkozatba is:

        p Tudomásul veszem, hogy az AKASA Pjt Adománygyűjtő oldal (8053 Bodajk Mandulás utca 36.) adatkezelő által az adomany.akasapjt.hu felhasználói adatbázisában tárolt alábbi személyes adataim átadásra kerülnek az OTP Mobil Kft., mint adatfeldolgozó részére. Az adatkezelő által továbbított adatok köre az alábbi: email cím, teljes név és lakcím. Az adatfeldolgozó által végzett adatfeldolgozási tevékenység jellege és célja a SimplePay Adatkezelési tájékoztatóban, az alábbi linken tekinthető meg: #[a(href='http://simplepay.hu/vasarlo-aff') http://simplepay.hu/vasarlo-aff]
</template>


<style lang='sass'>
    @import ../sass/variables

    main.pp
        h2
            margin-bottom: 2rem
            color: rgba($accent, 0.8)
        p
            margin-bottom: 2rem

</style>


<script>
import Vue from 'vue'

export default Vue.extend()
</script>